$(document).ready(function() {
  // Landing Enter Building Process
  $(".bundle-start").on("click", function (e) {
      e.preventDefault();
     $(".bab").hide();
     $(".bundle-step-2").show();
     scrollToAnchor('bundle-top');
  });
  
  // Step 2: Select Bundled Type Active State
   $(".bundle-type").on("click", function (e) {
    e.preventDefault();
    $(".bundle-type").removeClass('active');
    $(this).addClass('active');
    $(".bundle-step-2 .btn").attr("data-href", $(this).attr("data-href"));
  }); 
  //Step 2: Move onto next step with selected bundle type
  $(".bundle-step-2 .btn").on("click", function (e) {
    e.preventDefault();
    if ($(".bundle-step-2 .btn").attr("data-href") == "none"){
      return false;
    }
    $(".bab").hide();
    
    var cla = $(".bundle-step-2 .btn").attr("data-href");
    if(cla == "bundle-cans") {
      window.location.href = "https://www.kineuphorics.com/a/account/custom-tools/dynamic-box?product=7304903524394";
    } else if(cla == "bundle-bottles") {
      window.location.href = "https://www.kineuphorics.com/a/account/custom-tools/dynamic-box?product=7304904867882";
    } else {
      $(".bundle-step-3."+cla).show();
      scrollToAnchor('bundle-top');
    }
  });
  //Step 3: Previous Button brings back to Step 2
    $(".bundle-step-3 .btn.prev-step").on("click", function (e) {
         e.preventDefault();
       $(".bab").hide();
       $(".bundle-step-2").show();
       scrollToAnchor('bundle-top');
  });
  //Step 3: products size change
  $(".bundle-step-3 .bundle-size").on("click", function (e) {
       e.preventDefault();
       $(this).closest(".product-wrapper").find(".bundle-size").removeClass("active");
       $(this).addClass("active");
      $(".bundle-step-3 .btn.next-step").attr("data-href", $(".bundle-step-2 .btn").attr("data-href"));
     
  });
  //Step 3: Move onto next step with selected size
  //Sets the limitations
  $(".bundle-step-3 .btn.next-step").on("click", function (e) {
     e.preventDefault();
     if ($(".bundle-step-3 .btn.next-step").attr("data-href") == "none"){
         return false;
       }
     $(".bab").hide();
     var cla = $(this).closest(".bundle-step-3").find(".btn.next-step").attr("data-href");
     var claBot = $(this).closest(".bundle-step-3").find(".active .pill").attr("data-hb");
     var claCan = $(this).closest(".bundle-step-3").find(".active .pill").attr("data-hc");
     var cans= $(this).closest(".bundle-step-3").find(".active .pill").attr("data-cans");
     var bottles= $(this).closest(".bundle-step-3").find(".active .pill").attr("data-bottles");
     var bundleid=cla;

     var priceone = $(this).closest(".bundle-step-3").find(".active .pill").attr("data-ot");
     var pricesub = $(this).closest(".bundle-step-3").find(".active .pill").attr("data-sub");

    if(cans == "24") {
      window.location.href = "https://www.kineuphorics.com/a/account/custom-tools/sectioned-box?id=e02a543b-8efb-435f-bc18-d0e6e65c949f";
    } else if (cans == "12") {
      window.location.href = "https://www.kineuphorics.com/a/account/custom-tools/sectioned-box?id=c3072cfb-47e0-44af-aa99-8d166abe4f87";
    } else {
      $(".bundle-step-4 .product-price b").html(priceone);
      $(".bundle-step-4 .recharge-price b").html(pricesub);
       if (claCan != ""){
        $(".bundle-step-4 .type-cans."+claCan).show();
                        }
       if (claBot != ""){
         $(".bundle-step-4 .type-bottles."+claBot).show();
       } 
       $(".bundle-step-4 .atc").attr("data-name", $(".bundle-step-2 .btn").attr("data-href"));
       $(".bundle-step-4 .atc").attr("data-id", bundleid );
       // update price for sub and individual
       $(".bundle-step-4").show();
       if (cans != "0" && bottles != "0"){
          $(".bundle-step-4 .countdown-wrapper").html("0/"+cans+" Cans selected<br>0/"+bottles+" Bottles selected");
          $(".bundle-step-4 .countdown-wrapper").attr("data-cans", "0");
          $(".bundle-step-4 .countdown-wrapper").attr("data-bottles", "0");
          $(".bundle-step-4").attr("data-cans", cans);
          $(".bundle-step-4").attr("data-bottles", bottles);
         $(".bundle-step-4 .cans-footnote").show();
        }else{
          if(cans != "0"){
            $(".bundle-step-4 .countdown-wrapper").html("0/"+cans+ " Cans selected");
             $(".bundle-step-4 .countdown-wrapper").attr("data-cans", "0");
             $(".bundle-step-4").attr("data-cans", cans);
             $(".bundle-step-4").attr("data-bottles", "0");
            $(".bundle-step-4 .cans-footnote").show();
          }else{
            $(".bundle-step-4 .countdown-wrapper").html("0/"+bottles+" Bottles selected");
            $(".bundle-step-4 .countdown-wrapper").attr("data-bottles", "0");
            $(".bundle-step-4").attr("data-cans", "0");
            $(".bundle-step-4").attr("data-bottles", bottles);
          }
      }
       scrollToAnchor('bundle-top');
    }
  });
  //Step 4: Previous Button brings back to Step 3
  $(".bundle-step-4 .btn.prev-step").on("click", function (e) {
       e.preventDefault();
       $(".bab").hide();
       $(".bundle-product-item").hide();
       var cla = $(".bundle-step-2 .btn").attr("data-href");
       $(".bundle-step-3."+cla).show();
        $(".bundle-step-4 .countdown-wrapper").attr("data-cans", "0");
        $(".bundle-step-4 .countdown-wrapper").attr("data-bottles", "0");
        $(".bundle-step-4").attr("data-cans", "0");
        $(".bundle-step-4").attr("data-bottles", "0");
        $(".bundle-step-4 .countdown-wrapper").html("");
        $(".bundle-step-4 .qty-wrapper .qty").html("0");
        $(".bundle-step-4 .qty-wrapper .qty").attr("data-val", "0");
        $(".bundle-step-4 .min-plus").removeClass('disabled');
        $(".bundle-step-4 .btn.atc").addClass('disabled');
        $(".style-wrapper").html("");
        $(".bundle-step-4 .cans-footnote").hide();
        $(".bundle-step-4 .bundle-product-item").removeClass("adding");
     scrollToAnchor('bundle-top');
  });
  
$(".bundle-product-item .min-minus").on("click", function (e) {
  var qtyval = $(this).closest('.qty-wrapper').find(".qty").attr("data-val");
  if (qtyval == "0"){
    
     $(this).closest('.bundle-product-item').removeClass("adding");
    return false;
  }else{
     if ($(this).closest('.type-cans').length>0){
      qtyval = parseInt(qtyval) -4;
      totval = parseInt($(".bundle-step-4 .countdown-wrapper").attr("data-cans")) - 4 ;
    }else{
    qtyval = parseInt(qtyval) -1;
      totval = parseInt($(".bundle-step-4 .countdown-wrapper").attr("data-bottles")) - 1 ;
    }
    
    $(this).closest('.qty-wrapper').find(".qty").html(qtyval);
    $(this).closest('.qty-wrapper').find(".qty").attr("data-val", qtyval);
    if ($(this).closest('.type-cans').length > 0){
    $(".bundle-step-4 .countdown-wrapper").attr("data-cans", totval);
    }
    if ($(this).closest('.type-bottles').length > 0){
      $(".bundle-step-4 .countdown-wrapper").attr("data-bottles", totval);
    }
  }
  checkBundleqty();
});
  
$(".bundle-product-item .min-plus").on("click", function (e) {
  if ($(this).hasClass("disabled")){
    return false;
  }
  $(this).closest('.bundle-product-item').addClass("adding");
var qtyval = $(this).closest('.qty-wrapper').find(".qty").attr("data-val");
    if ($(this).closest('.type-cans').length>0){
      qtyval = parseInt(qtyval) +4;
      totval = 4 + parseInt($(".bundle-step-4 .countdown-wrapper").attr("data-cans"));
    }else{
    qtyval = parseInt(qtyval) +1;
      totval = 1 + parseInt($(".bundle-step-4 .countdown-wrapper").attr("data-bottles"));
    } 
    $(this).closest('.qty-wrapper').find(".qty").attr("data-val", qtyval);
    $(this).closest('.qty-wrapper').find(".qty").html(qtyval);
   if ($(this).closest('.type-cans').length > 0){
    $(".bundle-step-4 .countdown-wrapper").attr("data-cans", totval);
      }
    if ($(this).closest('.type-bottles').length > 0){
      $(".bundle-step-4 .countdown-wrapper").attr("data-bottles", totval);
    }
  checkBundleqty();
});

function checkBundleqty(){
  $(".bundle-step-4 .btn.atc").addClass('disabled');
  // both options
  if ($(".bundle-step-4").attr("data-bottles") != "0" && $(".bundle-step-4").attr("data-cans") != "0"){
    $(".bundle-step-4 .countdown-wrapper").html($(".bundle-step-4 .countdown-wrapper").attr("data-cans")+"/"+$(".bundle-step-4").attr("data-cans")+" Cans selected<br>"+$(".bundle-step-4 .countdown-wrapper").attr("data-bottles")+"/"+$(".bundle-step-4").attr("data-bottles")+" Bottles selected");
   
  if ($(".bundle-step-4 .countdown-wrapper").attr("data-bottles") == $(".bundle-step-4").attr("data-bottles")){
    $(".bundle-step-4 .type-bottles .min-plus").addClass('disabled');
  }else{
    $(".bundle-step-4 .type-bottles .min-plus").removeClass('disabled');
  }
  if ($(".bundle-step-4 .countdown-wrapper").attr("data-cans") == $(".bundle-step-4").attr("data-cans")){
   $(".bundle-step-4 .type-cans .min-plus").addClass('disabled');
  }else{
    $(".bundle-step-4 .type-cans .min-plus").removeClass('disabled');
  }
  if ($(".bundle-step-4 .countdown-wrapper").attr("data-bottles") == $(".bundle-step-4").attr("data-bottles") && $(".bundle-step-4 .countdown-wrapper").attr("data-cans") == $(".bundle-step-4").attr("data-cans") ){
     $(".bundle-step-4 .btn.atc").removeClass('disabled');
  }
  }else{
  //bottles
  if ($(".bundle-step-4 .countdown-wrapper").attr("data-bottles") == $(".bundle-step-4").attr("data-bottles") && $(".bundle-step-4").attr("data-bottles") != "0" ){
    $(".bundle-step-4 .type-bottles .min-plus").addClass('disabled');
    $(".bundle-step-4 .countdown-wrapper").html($(".bundle-step-4 .countdown-wrapper").attr("data-bottles")+"/"+$(".bundle-step-4").attr("data-bottles")+" Bottles selected");
    $(".bundle-step-4 .btn.atc").removeClass('disabled');
  }else{
    if ($(".bundle-step-4").attr("data-bottles") != "0"){
    $(".bundle-step-4 .type-bottles .min-plus").removeClass('disabled');
    $(".bundle-step-4 .countdown-wrapper").html($(".bundle-step-4 .countdown-wrapper").attr("data-bottles")+"/"+$(".bundle-step-4").attr("data-bottles")+" Bottles selected"); 
  }
    }
  //cans
  if ($(".bundle-step-4 .countdown-wrapper").attr("data-cans") == $(".bundle-step-4").attr("data-cans") && $(".bundle-step-4").attr("data-cans") != "0"){
    $(".bundle-step-4 .type-cans .min-plus").addClass('disabled');
    $(".bundle-step-4 .countdown-wrapper").html($(".bundle-step-4 .countdown-wrapper").attr("data-cans")+"/"+$(".bundle-step-4").attr("data-cans")+" Cans selected");
    $(".bundle-step-4 .btn.atc").removeClass('disabled');
  }else{
    if ($(".bundle-step-4").attr("data-cans") != "0"){
    $(".bundle-step-4 .type-cans .min-plus").removeClass('disabled');
    $(".bundle-step-4 .countdown-wrapper").html($(".bundle-step-4 .countdown-wrapper").attr("data-cans")+"/"+$(".bundle-step-4").attr("data-cans")+" Cans selected");
  }
  }
    }

  var totalval = parseInt($(".bundle-step-4 .countdown-wrapper").attr("data-bottles")) + parseInt($(".bundle-step-4 .countdown-wrapper").attr("data-cans"));
  var totalcart = parseInt($(".bundle-step-4").attr("data-bottles")) + parseInt($(".bundle-step-4").attr("data-cans"));
   if(totalval == totalcart){
        $(".style-wrapper").html("<style>.counter-container .Loading:after {width: 100%!important;}@keyframes loading {0% {width: 0;background: #63A57E;}100% { width: 100%;background:  #63A57E;}}</style>");
   }else{      
      var perc =  (   totalval / totalcart) * 100;
      $(".style-wrapper").html('<style>.counter-container .Loading:after {width: '+perc+'%!important;}@keyframes loading {0% {width: 0;background:#63A57E;}'+perc+'% { width: '+perc+'%;background:  #63A57E;}}</style>');
    }
}

//step 5 add to cart
$(".bundle-step-4 .btn.atc").on("click", function (e) {
     e.preventDefault();
    // add all items to cart
  if ($(this).hasClass("disabled")){
      return false;
  }else{
      var product_data ="[";
      var total = $('.bundle-product-item.adding').length;
      $('.bundle-product-item.adding').each(function(index) {
        var qtyval = $(this).find(".qty").attr("data-val");
        var idval = $(this).find(".qty").attr("data-vid");
        var bundleid = $(".bundle-step-4 .btn.atc").attr("data-id");
        var selling_plan = "";
        if ($('.subscription-purchase-wrapper.select').length > 0){
           selling_plan =',"selling_plan":'+$(this).find(".qty").attr("selling_plan");
        }
        
        if (qtyval > "0"){
          if ($(this).hasClass("type-cans")){
            qtyval = parseInt(qtyval) / 4;
          }
          if (index === total - 1) {
               product_data = product_data + '{"id":'+idval+',"quantity":'+qtyval+selling_plan+',"properties":{"Bundle": "'+bundleid+'"}}]';
          }else{
            product_data = product_data + '{"id":'+idval+',"quantity":'+qtyval+selling_plan+',"properties":{"Bundle": "'+bundleid+'"}},';
          }       
        }
     });

    const obj = JSON.parse(product_data);

    var data = {
    items: 
      obj
  }

      fetch('/cart/add.js', {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then((response) => {
      return response.json();
    }).then((json) => {
      /* yay! our products were added - do something here to indicate to the user */
      updateDrawer("add");
        
    }).catch((err) => {
      /* uh oh, we have error. */
      console.error(err)
    });
    }
  });

function scrollToAnchor(selector){
  const destination = $("a[name='"+ selector +"']");
    $('html,body').animate({
      scrollTop: destination.offset().top
    },'slow');
}

});